// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
export const COLORS = {
  surface: "#0e0e0e",
  surfaceLow: "#131313",
  surfaceContainer: "#1a1a1a",
  surfaceHigh: "#20201f",
  surfaceHighest: "#262626",
  primary: "#10b981",
  primaryDim: "#059669",
  primaryContainer: "#047857",
  secondary: "#00e3fd",
  secondaryContainer: "#006875",
  onSurface: "#ffffff",
  onSurfaceVariant: "#adaaaa",
  onPrimary: "#f0fdf4",
  onSecondary: "#004d57",
  outline: "#767575",
  outlineVariant: "#484847",
};
